<template>
  <div class="page">
    <div class="page-header">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="addItem"
        v-has="'add'"
      >
        {{ $t('model.addModel') }}
      </el-button>
    </div>
    <div class="page-main">
      <div class="page-tools">
        <el-form :inline="true" :model="tabelSearch">
          <el-form-item v-has="'delete'">
            <el-button
              type="primary"
              icon="el-icon-plus iconfont icon-delete"
              @click="deleteItem()"
              :disabled="!tableSelection.length"
            >{{ $t('delete') }}</el-button>
          </el-form-item>
          <el-form-item class="page-tools-right keywords" v-has="'list'">
            <el-input
              v-model="tabelSearch.keywords"
              :placeholder="$t('model.keywordsPla')"
              prefix-icon="el-icon-search"
              clearable
              @change="getTabelData"
            ></el-input>
          </el-form-item>
          <el-form-item class="page-tools-right" v-has="'list'">
            <select-model
              v-model="tabelSearch.model"
              selectAll
              @change="getTabelData"
            ></select-model>
          </el-form-item>
        </el-form>
      </div>
      <table-pagination
        memory="model"
        ref="refTable"
        :height="pageTabelHeight"
        :tableData="tableData"
        :columnData="columnData"
        selectionShow
        @selection-change="selectionChange"
        optionShow
        :optionMinWidth="120"
        columnOptionShow
        :total="tabelTotal"
        :currentPage.sync="tabelSearch.currentPage"
        :pageSize.sync="tabelSearch.pageSize"
        @changeCurrentPage="getTabelData"
        @sort-change="tabelSortChange"
      >
        <!-- option -->
        <template slot="option" slot-scope="scope">
          <el-tooltip
            effect="dark"
            :content="$t('setParameters')"
            placement="top"
            :open-delay="1000"
            v-has="'set'"
          >
            <el-button type="text" class="btn-p0" @click="setItem(scope.row)">
              <i class="el-icon-setting iconfont icon-setting"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip
            effect="dark"
            :content="$t('model.pushModelConfiguration')"
            placement="top"
            :open-delay="1000"
            v-has="'push'"
          >
            <el-button type="text" class="btn-p0" @click="pushItem(scope.row)">
              <i class="el-icon-s-promotion iconfont icon-push"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip
            effect="dark"
            :content="$t('model.editModelTemplate')"
            placement="top"
            :open-delay="1000"
            v-has="'edit'"
          >
            <el-button type="text" class="btn-p0" @click="editItem(scope.row.id)">
              <i class="el-icon-edit iconfont icon-edit"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip
            effect="dark"
            :content="$t('downloadConfigurationfile')"
            placement="top"
            :open-delay="1000"
            v-has="'download'"
          >
            <el-button type="text" class="btn-p0" @click="downloadItem(scope.row)">
              <i class="el-icon-download"></i>
            </el-button>
          </el-tooltip>
        </template>
      </table-pagination>
    </div>
    <!-- 推送任务 -->
    <dialog-configuration-push
      type="model"
      v-if="pushModelVisible"
      :title="pushModelTitle"
      :visible.sync="pushModelVisible"
      :req="pushModelReq"
      @scheduled="scheduledChange"
      :toolsDisplay="{
        keywordsShow: true,
        siteShow: true,
        modelShow: true,
        modelDisable: true,
      }"
    ></dialog-configuration-push>
    <!-- 推送定时任务 -->
    <dialog-scheduled-update
      v-if="scheduledUpdateVisible"
      :visible.sync="scheduledUpdateVisible"
      :req="scheduledUpdateReq"
    ></dialog-scheduled-update>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { TablePagination, SelectModel } from '@/components'
import { modelSearch, removeModelBatch, downloadModel } from '@/api/model'
import { downloadFile } from '@/plugins/methods'
import DialogConfigurationPush from '../dailog-push/dialog-configuration-push'
import DialogScheduledUpdate from '../dailog-push/dialog-scheduled-update'

export default {
  name: 'Model',
  components: {
    TablePagination,
    SelectModel,
    DialogConfigurationPush,
    DialogScheduledUpdate,
  },
  data() {
    return {
      tabelSearch: {
        currentPage: 1,
        pageSize: 10,
        sortField: 'updateTime',
        sortOrder: 'desc',
        keywords: null,
        model: null,
      },
      tabelTotal: 0,
      columnData: [
        {
          label: this.$t('model.templateName'),
          prop: 'templateName',
          minWidth: 200,
          sortable: 'custom',
        },
        {
          label: this.$t('model.model'),
          prop: 'modelName',
          minWidth: 200,
          sortable: 'custom',
        },
        {
          label: this.$t('ssite.site'),
          prop: 'siteName',
          minWidth: 200,
        },
        {
          label: this.$t('model.description'),
          prop: 'modelDesc',
          minWidth: 200,
        },
        {
          label: this.$t('dateModified'),
          prop: 'updateTime',
          minWidth: 200,
          sortable: 'custom',
          filter: 'dateFormat',
        },
      ],
      tableData: [],
      tableSelection: [],
      // 推送任务
      pushModelVisible: false,
      pushModelTitle: this.$t('model.pushModelConfiguration'),
      pushModelReq: {},
      // 推送定时任务
      scheduledUpdateVisible: false,
      scheduledUpdateReq: {},
    }
  },
  computed: {
    ...mapState('memory', ['sidebarSite']),
    ...mapGetters('session', ['pageTabelHeight']),
    tabelParams() {
      let data = { ...this.tabelSearch }
      data.site = this.sidebarSite
      return data
    },
  },
  watch: {
    sidebarSite() {
      this.getTabelData()
    },
  },
  created() {
    this.getTabelData()
  },
  methods: {
    // 获取数据
    getTabelData() {
      modelSearch(this.tabelParams)
        .then(({ data }) => {
          this.tableData = data.result.rows[0].list // 表格数据
          this.tabelTotal = data.result.rows[0].total // 表格数据条目
          this.$refs.refTable.clearFilter() // 表格过滤清空
        })
        .catch(() => {})
    },
    // 排序
    tabelSortChange({ order, prop }) {
      this.tabelSearch.sortOrder = order ? order : 'desc'
      this.tabelSearch.sortField = order ? prop : 'updateTime'
      this.getTabelData()
    },
    // 多选
    selectionChange(val) {
      this.tableSelection = val
    },
    // 增
    addItem() {
      this.$router.push('/model/addModel')
    },
    // 编辑
    editItem(id) {
      this.$router.push({ path: '/model/editModel', query: { id } })
    },
    // 设置设备参数
    setItem(row) {
      this.$router.push({
        path: '/model/setParam',
        query: { 
          relationName: 'model', 
          id: row.id,
          deviceModel: row.modelName,
         },
      })
    },
    // 下载
    downloadItem(row) {
      downloadModel({
        relationId: row.id,
        templateName: row.templateName,
        modeltype: row.modelName,
      }).then((res) => 
      {
        console.log("downloadItem", res),
        downloadFile(res)
      })
    },
    // 删
    deleteItem() {
      this.$confirm(this.$t('model.deleteTip'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(() => {
          const ids = this.tableSelection.map((e) => e.id),
            args = this.tableSelection.map((e) => e.templateName)
          removeModelBatch({ ids, args })
            .then(({ data }) => {
              this.$message.success(data.message)
              this.getTabelData()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    // 推送任务
    pushItem(row) {
      //console.log('pushItem site %s',row.siteId)
      this.pushModelReq.row = {
        id: row.id,
        relationName: 'model',
        model: [row.modelName],
        site: [row.siteId],
      }
      this.pushModelVisible = true
      this.site = [row.siteId]
    },
    // 推送定时任务
    scheduledChange(val) {
      this.scheduledUpdateVisible = true
      this.scheduledUpdateReq.data = val
    },
  },
}
</script>
